import { Component, OnInit } from '@angular/core';
import { RestaurantService } from '../../../../shared/services/restaurant/restaurant.service';
import { Router } from '@angular/router';

@Component({
  selector: 'app-restaurants',
  standalone: false,
  templateUrl: './restaurants.component.html',
  styleUrl: './restaurants.component.css',
})
export class RestaurantsComponent implements OnInit {
  search = '';

  listRestaurants: any[] = [];
  filteredRestaurants: any[] = [];

  /** 👇 NOVO: controla o "Carregando..." no template */
  isLoadingRestaurants: boolean = true;

  constructor(
    private restaurantService: RestaurantService,
    private router: Router
  ) {}

  ngOnInit(): void {
    this.loadRestaurants();
  }

  loadRestaurants(): void {
    // evita aparecer "Não encontramos resultados" durante a chamada da API
    this.isLoadingRestaurants = true;
    this.listRestaurants = [];
    this.filteredRestaurants = [];

    this.restaurantService.getAllRestaurants().subscribe(
      (response: any) => {
        const data = response?.data || [];
        this.listRestaurants = data;
        this.filteredRestaurants = data;

        this.isLoadingRestaurants = false;
      },
      () => {
        // em erro, para o loading e mantém lista vazia (aí sim cai no empty-state)
        this.listRestaurants = [];
        this.filteredRestaurants = [];
        this.isLoadingRestaurants = false;
      }
    );
  }

  filterRestaurants(): void {
    this.filteredRestaurants = this.listRestaurants.filter((item) =>
      (item?.name || '').toLowerCase().includes(this.search.toLowerCase())
    );
  }

  cancelSearch(): void {
    this.search = '';
    this.filterRestaurants(); // não precisa refazer chamada na API
  }

  openDetailsRestaurant(id: string): void {
    this.router.navigate(['restaurantes/', id]);
  }
}
